















































import { UserApi } from '@/api/user';
import userDetails from '@/components/settings/users/user-details.vue';
import userRoles from '@/components/settings/users/user-roles.vue';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const userApi = new UserApi();

@Component({
    components: {
        userDetails,
        userRoles,
    },
})
export default class EditUserDialog extends Vue {
    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private user!: User;

    private isVisible: boolean = this.visible;
    private isSaving: boolean = false;
    private currentTab: number = 0;
    private showDetailsError: boolean = false;

    private get showRolesError(): boolean {
        return this.user.roles.length < 1;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private async onSaveAsync(): Promise<void> {
        if (!(await (this.$refs.details as Vue).$validator.validateAll('user-details')) || this.user.roles.length < 1) {
            return;
        }

        this.isSaving = true;

        try {
            await userApi.updateUserAsync({
                ...this.user,
                id: this.user.id!,
                isArchived: this.user.isArchived!,
                roles: this.user.roles.map((role) => role.name),
                version: this.user.version!,
            });

            this.$emit('ok', { ...this.user });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not update user '${this.user.email}'.`, type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private onDetailsErrorsChanged(hasErrors: boolean): void {
        this.showDetailsError = hasErrors;
    }
}
